import Colors from '../../../Configs/colors';

const styles = {
  root: {
    '& .nav-container': {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      display: 'flex',
      justifyContent: 'center',
      border: 0,
      boxShadow: 'none',
      zIndex: 3,
      '& .navigation': {
        background: '#F9FBFC',
        border: '1px solid #E7F3FF',
        borderBottom: 0,
      },
      '& .MuiBottomNavigationAction-label': {
        marginTop: 4,
      },
      '& .MuiBottomNavigationAction-label.Mui-selected': {
        // color: `${Colors.redDark} !important`,
        background: '-webkit-linear-gradient(270deg, #9B225F 0%, #E40E41 100%)',
        color: 'transparent',
        '-webkit-text-fill-color': 'transparent',
        backgroundClip: 'text !important',
        '-webkit-background-clip': 'text !important',

        fontWeight: '700',
      },
    },
    '& main': {
      position: 'relative',
      '& .filter-btns': {
        overflow: 'auto',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
      },
      '& .filter-btn': {
        padding: '6px 8px',
        border: `1px solid ${Colors.grey}`,
        borderRadius: 8,
        cursor: 'pointer',
        whiteSpace: 'nowrap',
      },
      '& .info-card': {
        background: '#FDFDFD',
        padding: 16,
        borderRadius: 8,
        boxShadow: '2px 3px 6px rgba(0, 0, 0, 0.04), 0px 2px 8px rgba(0, 0, 0, 0.02)',
        border: '1px solid #F3F3F3',
        '& .status': {
          background: '#ECF5F8',
          fontSize: 14,
          padding: '4px 12px',
          borderRadius: 25,
          color: '#282828',
          fontWeight: '500',
        },
      },
      '& .upload-sect': {
        border: '1px dashed #6A6A6A',
        borderRadius: 8,
        background: '#F7F7FA',
        height: 120,
        width: 120,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#6A6A6A',
        cursor: 'pointer',
        '&.large': {
          width: 180,
        },
      },
    },
  },
};

export default styles;
